
var DefinitionFieldsNanny = function(){
    var children = [];

    // Add a child. Either a DefinitionFieldP or a DefinitionConditionP
    this.addChild = function(child) {
        children.push(child);
    };

    // Add a child after the field with id equal to parentId
    this.addChildAfter = function(parentId, child) {
        var idx = 0;

        children.forEach(function(child, i) {
            if (child.getId() === parentId) idx = i + 1;
        });

        children.splice(idx, 0, child);
    };

    this.removeChild = function(id) {
        var idx = 0;

        children.forEach(function(child, i) {
            if (child.getId() === id) idx = i;
        });

        return children.splice(idx, 1)[0];
    };

    this.getChildren = function(){
        return children;
    }

    this.empty = function(){
       children = [];
    }
};

export default DefinitionFieldsNanny;
